import type { SerializableValue } from '#app/zodSchemas/SerializableValueZodSchema.ts';
import { addBreadcrumb } from './addBreadcrumb.ts';
import JSON5 from 'json5';

type Options = {
  json5?: boolean;
};

export const parseJson = <T = SerializableValue>(
  subject: string,
  options?: Options,
): T => {
  try {
    if (options?.json5) {
      return JSON5.parse(subject);
    }

    // eslint-disable-next-line no-restricted-properties
    return JSON.parse(subject);
  } catch (error) {
    addBreadcrumb({
      data: {
        subject,
      },
      level: 'debug',
      message: 'could not parse JSON',
    });

    throw error;
  }
};
